import { useAllBackendChallenges } from 'features/Backend'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { randomNo } from 'utils'

import Challenges from '../Components/Challenges'

const BackendChallenges = () => {
  const router = useRouter()
  const [selectedDifficulties, setSelectedDifficulties] = useState<string[]>([])

  const { data: backendQuestions } = useAllBackendChallenges({})

  const onFeelingLucky = () => {
    if (!backendQuestions) return

    const maxIndex = backendQuestions.length
    const randomIdx = randomNo(0, maxIndex)

    const backendChallenge = backendQuestions[randomIdx]

    if (!backendChallenge) return
    router.push(
      `/backend-challenges/${backendChallenge.slug}/${backendChallenge.id}`
    )
  }

  return (
    <Challenges
      key={'Backend'}
      leaderboardType={'Backend'}
      showTopics={false}
      showCompany={false}
      questions={backendQuestions || []}
      selectedDifficulties={selectedDifficulties}
      onFeelingLucky={onFeelingLucky}
      setSelectedDifficulties={setSelectedDifficulties}
    />
  )
}

BackendChallenges.seo = {
  title: 'Solve Backend Questions - Devsnest',
  description:
    'Solve challenging Backend questions that have been asked by top tech companies to improve your coding abilities and get ready for interviews.',
  canonical: 'https://devsnest.in/backend-challenges',
  openGraph: {
    url: 'https://devsnest.in/backend-challenges'
  }
}

export default BackendChallenges
